export enum SigningProvider {
  NorwegianBankID = 'NBID',
  SwedishBankID = 'SBID',
}
